import StageRepository from '@/shared/http/repositories/configuration/stage'
import { mutationTypes as mutation } from './mutations'
import store from '@/store/'

const MODULE_NAME = 'stage/stages'
const GET_STAGE_BY_ID = 'getStageById'
const GET_ALL_STAGES_BY_AREA = 'getAllStageByArea'

export const actionTypes = {
  GET_STAGE_BY_ID,
  GET_ALL_STAGES_BY_AREA
}

export const actions = {
  [GET_STAGE_BY_ID] ({ commit }, payload) {
    commit(mutation.SET_STAGE, payload)
  },

  async [GET_ALL_STAGES_BY_AREA] ({ commit }, mnemonic, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
      StageRepository.GetAllByAreaMnemonic(mnemonic)
        .then((res) => {
          commit(mutation.SET_STAGES, res.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/stage/actions.js